var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payment-flow-animation',{attrs:{"result":_vm.result,"flow":"payment","overlay":false,"success-action-label":_vm.actionLabel,"error-action-label":_vm.actionLabel},on:{"action":_vm.goHome}})}
var staticRenderFns = []

export { render, staticRenderFns }